module.exports = __webpack_public_path__ + "static/media/react.70384772.svg";